import { useEffect, type ReactNode } from 'react';
import { LiveProgressBar } from './LiveSessionChrome';
import { useLiveSessionProgress } from './LiveSessionProgressContext';

export interface LiveToolScaffoldProps {
  title: string;
  subtitle?: string;
  /** Items completed (for progress bar). */
  progressDone?: number;
  progressTotal?: number;
  children: ReactNode;
  footer?: ReactNode;
}

export function LiveToolScaffold({
  title,
  subtitle,
  progressDone = 0,
  progressTotal = 0,
  children,
  footer,
}: LiveToolScaffoldProps) {
  const progressCtx = useLiveSessionProgress();

  useEffect(() => {
    if (progressTotal > 0) {
      progressCtx?.setProgress(progressDone, progressTotal);
    }
  }, [progressDone, progressTotal, progressCtx]);

  return (
    <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
      <div className="flex-1 overflow-y-auto px-5 sm:px-6 py-5">
        <div className="mb-4">
          <div className="font-display text-[1.15rem] font-light text-[var(--text-pri)] mb-1">{title}</div>
          {subtitle && (
            <div className="font-body text-[0.78rem] font-light text-[var(--text-ter)]">{subtitle}</div>
          )}
        </div>
        {progressTotal > 0 && (
          <LiveProgressBar placed={progressDone} total={progressTotal} />
        )}
        {children}
      </div>
      {footer}
    </div>
  );
}
